import React, { type FC } from 'react'
import classNames from 'classnames'
import { Avatar, AvatarGroupInLine, type IAvatarInfo, Typography } from 'shared/ui'
import { type User } from 'entities/Users/model/User'
import styles from './styles.module.scss'

type IForwardToInboxMembersProps = {
  info: User[]
}

export const ForwardToInboxMembers: FC<IForwardToInboxMembersProps> = ({ info }) => {
  const showNoAnswerView = info.length > 1
  const count = info.length < 3 ? info.length : 3
  const avatarInfo: IAvatarInfo = {
    firstName: info[0]?.first_name || '',
    lastName: info[0]?.last_name || '',
    image: info[0]?.photo_url || '',
  }

  const avatarInfoList: IAvatarInfo[] = info.map((item) => {
    return {
      firstName: item?.first_name || '',
      lastName: item?.last_name || '',
      image: item?.photo_url || '',
    }
  })
  return (
    <div className={classNames(styles.content)}>
      <div
        className={classNames(styles.wrapIcon, {
          [styles[`count_${count}`]]: !!count,
        })}
      >
        {showNoAnswerView ? (
          <AvatarGroupInLine items={avatarInfoList} size={16} />
        ) : (
          <Avatar info={avatarInfo} size={16} />
        )}
      </div>
      <Typography
        tag={'div'}
        variant={'body-sm-regular'}
        color={'var(--content-primary-primary)'}
        ariaLabel={'forward_to_inbox_members'}
        tooltipProps={{
          label: showNoAnswerView ? `${info.length} members` : info[0]?.full_name,
        }}
        ellipsis
      >
        {showNoAnswerView
          ? `Forwarded to ${info.length} members`
          : `Forwarded to “${info[0]?.full_name}”`}
      </Typography>
    </div>
  )
}
